// extracted by mini-css-extract-plugin
export default {"editControl":"System_editControl__AMTre","editSpinner":"System_editSpinner__594fr"};